import './Promo.css';
export default function Promo({ conference }) {
    const data = conference?.promoData;

    if (!data || !data.title) {
        return ''; 
    }

    return `
        <section id="promo" class="promo-section">
            <div class="container">
                <div class="promo__card">
                    <div class="promo__icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="16" x2="12" y2="12"></line>
                            <line x1="12" y1="8" x2="12.01" y2="8"></line>
                        </svg>
                    </div>
                    <div class="promo__text">
                        <h3 class="promo__title">${data.title}</h3>
                        <div class="promo__content">
                            ${data.content}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    `;
}
